
import request from 'common/util/request';
import Jt from "common/util/jt.js";
const Jt_B = Jt.base;

console.log(process.env.BUILD_TYPE) // prod
const zxbApiBasic = process.env.BUILD_TYPE === "prod"
                    ? 'https://newsdata.peopletech.cn/appapi'
                    : 'http://lucky.peopletech.cn/clientapi';

export function getWxSdk() {
    return request('https://appwx.people.cn/static/peopletech/jssdk.php', {
        method: 'get',
        data: {
           url: encodeURIComponent(window.location.href.split('#')[0])
        }
    });
}

export function getDetail(params, cb) {
    return request(`/miapi/detail/${params.id}/micard`, {
        method: 'get',
        cb: cb,
        async: false
    });
}

// export function getSubject(params) {
//     return request(`/subject/${params.id}`, {
//         method: 'get'
//     });
// }

export function getRcmd(params) {
    return request(`/recommend/${params.id}/${Jt_B.getLocalData('lang') || 'cn'}`, {
        method: 'get',
    });
}

export function getMoreNewsAction(params) {
    return request(`/moreNewsAction`, {
        method: 'get'
    });
}



// 专题应用资讯部的专题
export function getSubject(params, cb) {
    const d = Jt_B.parseQueryString(window.location.href)['d'];
    return request(`${zxbApiBasic}/miSubject/detail?id=${params.id}${d ? '&d=' + d : ''}`, {
        method: 'get',
        cb: cb,
        async: true
    });
}

// 来自咨询部的新闻详情
export function getZxbDetail(params, cb) {
    const d = Jt_B.parseQueryString(window.location.href)['d'];
    return request(`${zxbApiBasic}/miDetail/${params.id}${d ? '?d=' + d : ''}`, {
        method: 'get',
        cb: cb,
        async: false
    });
}




// WEBPACK FOOTER //
// ./src/common/service/server-api.js